import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { ViewportTagIssues } from '../../../constants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Reason = ({
  viewportTagIssue
}) => {
  switch (viewportTagIssue) {
    case ViewportTagIssues.NO_VIEWPORT_FOUND:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.reasons.ADD_VIEWPORT_TAG.NO_VIEWPORT_FOUND"
      });
    case ViewportTagIssues.VIEWPORT_FOUND_WITH_INCORRECT_CONTENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.reasons.ADD_VIEWPORT_TAG.VIEWPORT_FOUND_WITH_INCORRECT_CONTENT"
      });
    case ViewportTagIssues.MULTIPLE_VIEWPORT_TAGS_FOUND:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.reasons.ADD_VIEWPORT_TAG.MULTIPLE_VIEWPORT_TAGS_FOUND"
      });
    default:
      console.error('No translation found for this viewport meta tag issue: ', viewportTagIssue);
      return null;
  }
};
export const AddViewportTagView = ({
  auditResult
}) => {
  const {
    status,
    viewportTagIssue
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_VIEWPORT_TAG"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_VIEWPORT_TAG"
    }),
    status: status,
    children: viewportTagIssue && /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      as: "div",
      children: /*#__PURE__*/_jsx(Reason, {
        viewportTagIssue: viewportTagIssue
      })
    })
  });
};